
import { sendPost } from '../http.js'
const api = {
	'incomeStatistics': {
        url: '/user/order/income/statistics'
    },
	'applyRecord': {
        url: '/user/user/cash/apply/record'
    },
	'getSurplus': {
        url: '/user/user/surplus'
    },
	'getAccount': {
        url: '/user/user/account'
    },
	'bindAccount': {
        url: '/user/user/bind/account'
    },
    'getValidateQrcodeAPI': { // 获取富友验证url二维码
        url: '/user/user/query/check_url'
    },
    'getAccountMerchantDetailAPI': { // 获取账户和对应商户详情
        url: '/user/user/account/merchant/detail'
    },
	'removeAccount': {
        url: '/user/user/remove/account'
    },
	'cashApply': {
        url: '/user/user/cash/apply',
        extraErrobj: {showText:false, backAllErrObj:true}
    },
    'oldBankToFuyouAPI': { // 老银行卡提交给富友
        url: '/user/user/bind/account/fuyou'
    },
	'bankOption': { // 银行列表
        url: '/common/bank/option'
    },
	'incomeList': {
        url: '/user/order/income/list'
    },
    'EditProductSort': {
        url: '/user/user/product/sort'
    },
    'sendSms': {
        url: '/user/user/send/sms'
    },
    'checkSmsCode': {
        url: '/user/user/check/sms/code'
    },
    'checkMasterPwd': {
        url: '/user/user/check/master/pwd'
    },
    'editinfoPhone': {
        url: '/login/login/editinfo'
    },
    'channelAccount': { // 抖音or快手账号列表
        url: '/user/channel/account'
    },
    'orderDetail': {
        url: '/user/order/detail'
    },
    'retryPutApi': {
        url: '/doushop/sync/coupon'
    },
	'authorCourse': {
		 url: '/author/course/getcourse'
	},
    'wxAuthorCourseAPI': { // 微信小店订单课程筛选列表
        url: '/author/course/getwxcourse'
   },
    'studyRecord': {
        url: '/user/order/study_record'
   },
   'logisticsList': {
       url: '/user/order/logistics_list'
   },
   'expressCompany': {
       url: '/user/order/express_company'
   },
   'sendout': {
       url: '/user/order/sendout'
   },
    'orderEdit': {
        url: '/user/order/edit'
    },
    'orderRefund': {
        url: '/user/order/refund'
    },
    'refundStatus': {
        url: '/user/order/refund/status'
    },
    'orderAppeal':{
        url:'/user/order/appeal'
    },
    'appealAudit':{
        url:'/user/order/appeal_audit'
    },
    'czmCanSettle': {
        url: '/user/order/czm_can_settle'
    },
	'agreementList': {
	    url: '/user/user/agreementlist'
	},
	'agreementDetail': {
	    url: '/user/user/agreementdetail'
	},
    'specSave': {
        url: '/user/spec/save'
    },
    'specIndex': {
        url: '/user/spec/index'
    },
    'specDetail': {
        url: '/user/spec/detail'
    },
    'tableHeader':{
        url:'/user/order/list/settings/show'
    },
    'settings':{
        url:'/user/order/list/settings'
    },
	'getCompleteMobile':{
        url: '/user/complete/mobile'
    },
    'logistics_import_index':{
        url:'/user/order/logistics_import_index'
    },
    editSendout: {
        url: '/user/order/edit/sendout'
    },
    // 提交申请退款
    submitOrderRefund:{
        url: '/user/order/order_refund'
    },
    specDel: {
        url: '/user/spec/del'
    },
    editIsShowMobile: {
        url: '/login/login/account/is_show_mobile'
    },
    depositHistoryList: {
        url: '/user/user/deposit_money/deduct_log'
    },
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            if(api[key].extraErrobj){
                return sendPost(api[key].url, params, api[key].method || 'post', {}, api[key].extraErrobj)
            }else{
                return sendPost(api[key].url,params,api[key].method || 'post')
            }
        }
    } 
}
export default requestFunObj
